import { deleteNormalizedEntity } from '@iconik-io/shared-lib/src/redux/entities/slice';

import type { AppDispatch, GetState } from '../../store/types';

export const cleanupDeletedFileSets =
  () => (dispatch: AppDispatch, getState: GetState) => {
    const state = getState();
    for (const [id, fileSet] of Object.entries(state.entities.file_sets)) {
      if (fileSet.status === 'DELETED') {
        dispatch(deleteNormalizedEntity({ key: 'file_sets', id }));
      }
    }
  };
